import { render, staticRenderFns } from "./ModalFriendsFilter.vue?vue&type=template&id=5fb810bc&scoped=true&"
import script from "./ModalFriendsFilter.vue?vue&type=script&lang=js&"
export * from "./ModalFriendsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ModalFriendsFilter.vue?vue&type=style&index=0&id=5fb810bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb810bc",
  null
  
)

export default component.exports